import Tpl1 from '../../../../class/service/rv/Tpl1'
import Tpl1ForSingle from '../../../../class/service/rv/Tpl1ForSingle'
import App from '../../../../class/App.js'
import SingleOfferTemplatLoader from "../../../../class/templateLoader/SingleOfferTemplatLoader"
import {getUrlParams} from "../../../../common/util"


window.MTG_LAUNCH_tpl1 = function (cb) {
    const query = getUrlParams()
    let templateClass = Tpl1
    console.log('window.query===》', query)
    if(query.createByAtmosphere === '1'){
        console.log('query.createByAtmosphere===》', query)
        templateClass = Tpl1ForSingle
    }


    App.onJSBridgeConnected(()=>{init()})
    function init(){
        App.loadTemplate({
            templateClass,
            templateLoader: SingleOfferTemplatLoader,
            loadCallback: cb
        }).then(({data, tpl})=>{
            //App.readyToShowAD()
            tpl.whenLoad().then(() => {
                console.log('entry tpl1.whenLoad ============>')
                App.readyToShowAD()
            }).catch(() => {
                console.log('entry tpl1.whenLoad err============>')
                App.failureToShowAD()
            })
        }).catch(err=>{
            console.error('promise catch an error:',err)
        })
    }
}
